"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShippingCountry = exports.haveKnownShippingCountry = exports.getShippingCountryInitialized = exports.getKnownShippingCountry = exports.defaultCountry = void 0;
var reselect_1 = require("reselect");
var cartSelectors_1 = require("../cartSelectors");
exports.defaultCountry = 'US';
exports.getKnownShippingCountry = (0, reselect_1.createSelector)(cartSelectors_1.getCart, function (shoppingCart) {
    if (!shoppingCart) {
        return null;
    }
    var shippingCountry = shoppingCart.shippingCountry;
    if (!shippingCountry) {
        return null;
    }
    return (shippingCountry.setCountry || shippingCountry.automaticCountry || null);
});
exports.getShippingCountryInitialized = (0, reselect_1.createSelector)(cartSelectors_1.getCart, function (shoppingCart) { var _a; return (_a = shoppingCart.shippingCountry) === null || _a === void 0 ? void 0 : _a.shippingCountryInitialised; });
exports.haveKnownShippingCountry = (0, reselect_1.createSelector)(exports.getKnownShippingCountry, function (knownShippingCountry) { return !!knownShippingCountry; });
exports.getShippingCountry = (0, reselect_1.createSelector)(exports.getKnownShippingCountry, function (knownShippingCountry) { return knownShippingCountry || exports.defaultCountry; });
exports.default = exports.getShippingCountry;
